module.exports = __webpack_public_path__ + "static/media/contentBoard.d79b4cbe.svg";